"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _datadog = require("./datadog");
var _default = options => {
  (0, _datadog.ddInit)(options);
  const debug = async (message, context) => {
    return await (0, _datadog.ddLog)(message, context, 'debug');
  };
  const error = async (message, context) => {
    return await (0, _datadog.ddLog)(message, context, 'error');
  };
  const info = async (message, context) => {
    return await (0, _datadog.ddLog)(message, context, 'info');
  };
  const warning = async (message, context) => {
    return await (0, _datadog.ddLog)(message, context, 'warning');
  };
  return {
    debug,
    error,
    info,
    warning
  };
};
exports.default = _default;